import React from "react";

import {
    FaChartLine,
} from "react-icons/fa";

import SectionCard from "./SectionCard";

import {
    formatCurrency,
    formatNumber,
} from "../utils/dashboardFormatters";


const SalesTrendOverview = ({
    data = [],
}) => {

    const safeData =
        Array.isArray(
            data
        )
            ? data
            : [];


    const maxSales =
        safeData.length > 0
            ? Math.max(
                ...safeData.map(
                    (
                        item
                    ) =>
                        Number(
                            item?.sales ||
                            0
                        )
                ),
                1
            )
            : 1;


    return (

        <SectionCard
            title="Sales Trend"
            subtitle="Sales performance across the selected date range."
        >

            {
                safeData.length === 0
                    ? (

                        <div className="dashboard-trend-empty">

                            <FaChartLine />


                            <h4>
                                No sales trend data
                            </h4>


                            <p>
                                Sales trend will appear when trend data is available.
                            </p>

                        </div>

                    )
                    : (

                        <div className="dashboard-sales-trend">

                            {
                                safeData.map(
                                    (
                                        item,
                                        index
                                    ) => {

                                        const sales =
                                            Number(
                                                item
                                                    ?.sales ||
                                                0
                                            );


                                        const height =
                                            Math.max(
                                                (
                                                    sales /
                                                    maxSales
                                                ) *
                                                100,
                                                3
                                            );


                                        return (

                                            <div
                                                key={
                                                    `${
                                                        item
                                                            ?.label ||
                                                        "sales"
                                                    }-${index}`
                                                }

                                                className="dashboard-trend-item"
                                            >

                                                <div className="dashboard-trend-tooltip">

                                                    <strong>
                                                        {
                                                            formatCurrency(
                                                                sales
                                                            )
                                                        }
                                                    </strong>


                                                    <span>
                                                        {
                                                            formatNumber(
                                                                item
                                                                    ?.invoices
                                                            )
                                                        }
                                                        {" "}
                                                        invoices
                                                    </span>

                                                </div>


                                                <div className="dashboard-trend-bar-area">

                                                    <div
                                                        className="dashboard-trend-bar"

                                                        style={{
                                                            height:
                                                                `${height}%`,
                                                        }}
                                                    />

                                                </div>


                                                <span className="dashboard-trend-label">

                                                    {
                                                        item?.label ||
                                                        "-"
                                                    }

                                                </span>

                                            </div>

                                        );

                                    }
                                )
                            }

                        </div>

                    )
            }

        </SectionCard>

    );

};


export default SalesTrendOverview;